import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';
import { getFirestore } from 'firebase/firestore';

// TODO: Replace with your app's Firebase project configuration.
// You can get this from the Firebase console for your web app.
const firebaseConfig = {
  apiKey: "AIzaSyAuIom0zRBmszSMYieI7ayE4_kZZC83274",
  authDomain: "rasp-map.firebaseapp.com",
  projectId: "rasp-map",
  storageBucket: "rasp-map.firebasestorage.app",
  messagingSenderId: "291484231642",
  appId: "1:291484231642:web:c21e5d5a7f9bb5523582e3",
  measurementId: "G-Q56WDJWXY7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Analytics and get a reference to the service
export const analytics = getAnalytics(app);

// Initialize Firestore
export const db = getFirestore(app);